import { create } from "zustand";

/**
 * SERV-3232: the entity of the record a detail route has open in the merged view, sent as the
 * acting entity ahead of the label-menu pick so the page's reads and writes run in the record's
 * entity. Not persisted: it belongs to the open route, and a reload sets it again from the URL.
 */
interface RecordTenantStore {
  recordTenant: string | null;
  setRecordTenant: (recordTenant: string) => void;
  clearRecordTenant: () => void;
}

export const useRecordTenantStore = create<RecordTenantStore>()((set) => ({
  recordTenant: null,
  setRecordTenant: (recordTenant) => set({ recordTenant }),
  clearRecordTenant: () => set({ recordTenant: null }),
}));
